import script from "./RelatedProducts.vue?vue&type=script&setup=true&lang=js"
export * from "./RelatedProducts.vue?vue&type=script&setup=true&lang=js"

import "./RelatedProducts.vue?vue&type=style&index=0&id=4ff54686&scoped=true&lang=css"

import exportComponent from "/var/www/vhosts/mayesh.com/httpdocs/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4ff54686"]])

export default __exports__